import React, {useEffect, useState } from "react";
import SeprateFaq from "./OrobondsFaq";

export default function OrobondsFaqs(props){
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        setIsMobile(window.matchMedia("(max-width: 768px)").matches);
        }, []);

    return(
        <SeprateFaq isMobile={isMobile} toggle={props.toggle} />
    )
}